import { formatDateYmd } from 'features/common/helpers/datePresets';
import { BSP_PERIODS_PY } from './periodsPy';
import { BSP_PERIODS_UY } from './periodsUy';
import { BspMarket, BspPeriodOption } from './types';

export type { BspMarket, BspPeriodOption } from './types';
export { BSP_PERIODS_UY } from './periodsUy';
export { BSP_PERIODS_PY } from './periodsPy';

const PERIODS_BY_MARKET: Record<BspMarket, BspPeriodOption[]> = {
	UY: BSP_PERIODS_UY,
	PY: BSP_PERIODS_PY,
};

export const getBspPeriods = (market: BspMarket): BspPeriodOption[] => PERIODS_BY_MARKET[market];

export const findBspPeriod = (market: BspMarket, periodName: string): BspPeriodOption | undefined =>
	getBspPeriods(market).find((period) => period.name === periodName);

export const findBspPeriodForDate = (market: BspMarket, date: Date = new Date()): BspPeriodOption | undefined => {
	const ymd = formatDateYmd(date);
	return getBspPeriods(market).find((period) => ymd >= period.from_date && ymd <= period.to_date);
};

export const findAdjacentBspPeriod = (
	market: BspMarket,
	period: BspPeriodOption,
	direction: 'previous' | 'next',
): BspPeriodOption | undefined => {
	const periods = getBspPeriods(market);
	const index = periods.findIndex((item) => item.name === period.name);
	if (index === -1) return undefined;
	const targetIndex = direction === 'previous' ? index - 1 : index + 1;
	return periods[targetIndex];
};

export const parseBspCreatedValue = (value: string): { market: BspMarket; periodName: string } | null => {
	const [market, periodName] = value.split(':');
	if ((market !== 'UY' && market !== 'PY') || !periodName) return null;
	return { market, periodName };
};

export const formatBspCreatedValue = (market: BspMarket, periodName: string): string => `${market}:${periodName}`;
